import React, {useRef, useState} from 'react'
import { Header, Icon , Button, Divider, Modal} from 'semantic-ui-react'
import UserForm from './UserForm'

const UserEdit = ({rowId, userId, data, onSubmit, updateUser, isAdmin}) => {
    const [open, setOpen] = useState(false)
    const [canSave, setCanSave] = useState(false)
    const userEditFormRef = useRef(null)

    const onClose = () => {
        setOpen(false)
    }

    const onOpen = () => {
        setOpen(true)

    }

    const onClick = ()  => {
        userEditFormRef.current.submit(onSubmit) // Submit form values
        setOpen(false)
    }


    const onSave = (values) => {
        const payload = {
            id: rowId,
            email_user: values.email_user,
            full_name: values.fullname,
            company: values.company
        }
        // Only an admin may change admin rights; send the flag only in that case
        // so a non-admin edit never accidentally demotes/promotes the user.
        if (isAdmin) payload.admin = values.admin ? 1 : 0
        updateUser(payload)

    }


    const updateValidationBtnState = (canSave) => {
        setCanSave(canSave)
    };

    return <Modal size='small' open={open} dimmer='inverted'
                   trigger={<Icon name='write' size='large' onClick={onOpen}/>} >
                <Modal.Header>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='user'/>
                            <Icon corner name='write'/>
                        </Icon.Group>
                        Update license data for {userId}
                    </Header>
                </Modal.Header>
                <Modal.Content>
                    <UserForm ref={userEditFormRef} onSubmit={onSave} isAdmin={isAdmin}
                                 onUpdateValidationState={updateValidationBtnState} initialValues={data}/>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={onClick} disabled={canSave}>
                        <Icon name='write'/>Update user
                    </Button>
                    <Button onClick={onClose}>
                        <Icon name='user cancel' />Cancel
                    </Button>
                </Modal.Actions>
            </Modal>

}

export default UserEdit

